<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiReloadAlert } from "@mdi/js";
export default {
  name: "MdiReloadAlert",
  data() {
    return {
      svgPath: mdiReloadAlert,
    };
  },
};
</script>
